








import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from './components/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '20231222GCYS';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '首页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '打卡',
      path: `/${baseUrl}/save`,
      id: 2,
    },
    {
      title: '规则',
      path: `/${baseUrl}/rule`,
      id: 3,
    },
    {
      title: '我的',
      path: `/${baseUrl}/user`,
      id: 4,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/webupload/o_1hife0osd1qp9guc2od15v1te17.png';
    // App分享
    this.$appShareInfo({
      title: '国潮养生',
      url: location.href,
      subtitle: `2023养固健“潮”养生息打卡活动`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin() && this.$route.path !== '/20231222GCYS/save') {
      this.$wxShareInfo({
        title: '国潮养生',
        subtitle: `2023养固健“潮”养生息打卡活动`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
